import { visit } from "unist-util-visit";

let regex = /<@(\w+)>/g;

export default function userMentions() {

    return (tree: any) => {
        visit(tree, 'text', (node: any, index: any, parent: any) => {

            if (node.value.match(regex)) {
                let parts = node.value.split(regex);
                let newNode: any = {
                    type: 'element',
                    tagName: 'span',
                    properties: {},
                    children: [] as any[]
                }
                parts.forEach((part: any, index: any) => {
                    if (index % 2 === 0) {
                        newNode.children.push({
                            type: 'text',
                            value: part
                        });
                    } else {
                        newNode.children.push({
                            type: 'element',
                            tagName: 'mention',
                            properties: { className: 'mention' },
                            children: [{ type: 'text', value: "<@" + part + ">" }]
                        });
                    }
                });

                parent.children[index] = newNode;
            }
        });
    }
}